import { css } from 'linaria';

export const input = css`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
    -webkit-appearance: none;
  }

  input[type='number'] {
    -moz-appearance: textfield; /* Firefox */
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    width: 100%;
  }
`;
